export const PREQUALIFIED_RECEIPT_ID = '2331';
export const PURCHASE_PREQUALIFIED_RECEIPT_ID = '3088';
export const PURCHASE_USED_PREQUALIFIED_RECEIPT_ID = '3130';
